import React from "react";
import Input from "shared/Input";
import Button from "shared/Button";
import { colors } from "styles/colors";
import { SearchWrap, IconWrap } from "./styled";
import { Icon } from "components/SvgIcons";

function SearchForm({ value, onChange, onClick }) {
  const onEnterClick = (e) => {
    if (e.charCode === 13) {
      onClick();
    }
  };
  return (
    <SearchWrap>
      <IconWrap>
        <Icon icon="search_2" />
      </IconWrap>
      <Input
        id="search"
        name="search"
        text="Search"
        type="search"
        onKeyPress={onEnterClick}
        value={value}
        placeholder="Search"
        onChange={(e) => onChange(e.target.value)}
      />
      <Button
        bdButton={colors.WHITE}
        iconRight="search_2"
        color={colors.RED}
        textColor={colors.WHITE}
        text="Search"
        stylType="primary"
        btnSize="larger"
        onClick={onClick}
      />
    </SearchWrap>
  );
}

export default SearchForm;
